import React, { useEffect, useRef } from "react";

const FilterDropDown = ({ isFilterOpen, filters, filterBooks, resetFilters }) => {
    const filterRefs = useRef({});

    useEffect(() => {
        if (resetFilters) {
            Object.values(filterRefs.current).forEach((checkbox) => {
                if (checkbox) checkbox.checked = false;
            });
        }
    }, [resetFilters]);

    if (!isFilterOpen) return null;

    return (
        <div className="absolute top-full left-0 mt-1 z-20 w-48 bg-white border border-warm-200 rounded-xl shadow-lg overflow-hidden">
            <ul className="max-h-60 overflow-y-auto py-1">
                {Object.entries(filters).map(([key, value]) => (
                    <li key={value.id}>
                        <label className="flex items-center gap-2.5 px-3 py-2 hover:bg-warm-50 cursor-pointer transition-colors">
                            <input
                                ref={el => filterRefs.current[value.id] = el}
                                type="checkbox"
                                value={value.name}
                                onChange={() => filterBooks(value.id)}
                                className="w-3.5 h-3.5 cursor-pointer rounded border-warm-300 accent-[#8a5230]"
                            />
                            <span className="text-sm text-warm-700">{value.name}</span>
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FilterDropDown;
